// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3hy4R","title":"BackImages_title__RflyP","images":"BackImages_images__Szu_T"};